<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="609"
          @click:outside="closeModal"
          :retain-focus="false"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                Group Name
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-form lazy-validation autocomplete="off">
              <v-card-text class="black--text pa-8">
                <v-row>
                  <v-col cols="12">
                    <label>Enter Group Name</label>
                    <v-text-field
                      placeholder="Type Here"
                      outlined
                      dense
                      v-model="group"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-divider class="mt-1"></v-divider>
                <v-card-actions class="mt-5" style="padding-right: 0">
                  <v-spacer></v-spacer>
                  <v-btn
                    outlined
                    class="mr-2"
                    right
                    height="44"
                    width="116"
                    depressed
                    color="primary"
                    @click="closeModal()"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    right
                    height="44"
                    width="116"
                    color="primary"
                    @click="createGroupForUngrouppedAnimal"
                  >
                    Create
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>
import { createGroupForUngrouppedAnimal } from "@/graphql/Animals.gql";
import { mapGetters } from "vuex";
import loadingMixin from "@/mixins/LoadingMixin";
export default {
  data() {
    return {
      group: "",
    };
  },
  computed: {
    ...mapGetters(["ungrouppedAnimal"]),
    dialog() {
      return this.dialogI;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },
    createGroupForUngrouppedAnimal() {
      this.startLoading();
      const data = {
        name: this.group,
        status: "active",
        ungrouppedAnimals: this.ungrouppedAnimal.map((animal) =>
          Number(animal.id)
        ),
      };
      return this.$apollo
        .mutate({
          mutation: createGroupForUngrouppedAnimal,
          variables: {
            createGroupForUngrouppedAnimalInput: data,
          },
        })
        .then((res) => {
          this.stopLoading();
          if (res?.data?.createGroupForUngrouppedAnimal) {
            this.$notify({
              title: "Success!",
              text: "Group created successfully!!",
              type: "success",
            });
          }
          this.closeModal();
          this.$emit("updateTable");
        })
        .catch((e) => {
          this.stopLoading();
          this.$notify({
            title: "Error!",
            text: e?.graphQLErrors[0].message,
            type: "error",
          });
          Promise.reject(e);
        });
    },
  },
  mixins: [loadingMixin],
};
</script>

<style></style>
